/* Tysk katalog for locale-no.js (del 7 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'bg.balanceDiscrepancy': 'Saldoabweichung',
  'bg.notCorrect': 'Nicht korrekt',
  'bg.reconciliationDone': 'Die Bankabstimmung ist abgeschlossen',
  'bg.reconciliationDoneHelp': 'Der Kontoauszug wurde geprüft, gebucht und ins Archiv verschoben.',
  'bg.bankLines': 'Bankzeilen',
  'bg.reconciled': 'Abgestimmt',
  'bg.backToBank': 'Zurück zu Bank',
  'bg.reopenReconciliation': 'Abstimmung wieder öffnen',
  'bg.bankAccountCaps': 'BANKKONTO',
  'bg.periodCaps': 'ZEITRAUM',
  'bg.balanceAtStart': 'Saldo zu Beginn des Zeitraums',
  'bg.balanceAtEnd': 'Saldo am Ende des Zeitraums',
  'bg.balancesMatch': 'Die Salden stimmen überein.',
  'bg.roundingHelp': 'Dies kann auf das Rundungskonto 7770 gebucht werden, ohne den Betrag aus dem Kontoauszug zu ändern.',
  'bg.balancesMatchContinue': 'Die Salden stimmen – weiter',
  'bg.suggestionsHeading': 'SuperPlumma hat zugeordnet und Buchungen vorgeschlagen — du entscheidest',
  'bg.noSuggestions': 'Keine Vorschläge warten auf Genehmigung.',
  'bg.continueToRest': 'Weiter zum Rest',
  'bg.noPostedDiscrepancies': 'Keine gebuchten Positionen verursachen Abweichungen.',
  'bg.checkAndFix': 'Prüfe und korrigiere die Positionen, bevor der Zeitraum abgeschlossen wird.',
  'bg.allPaymentsHandled': 'Alle Zahlungen sind bearbeitet.',
  'bg.continueToVouchers': 'Weiter zu den Belegen',
  'bg.allPurchasesDocumented': 'Alle Einkäufe haben die nötige Dokumentation oder sind als ohne Beleg markiert.',
  'bg.seePurchase': 'Einkauf ansehen',
  'bg.withoutVoucher': 'Ohne Beleg',
  'bg.linkSuggested': 'Vorschlag verknüpfen',
  'bg.pickVoucher': 'Beleg wählen',
  'bg.continueToFinish': 'Weiter zum Abschluss',
  'bg.bankLinesTotal': 'Bankzeilen gesamt',
  'bg.linkedPosted': 'Verknüpft/gebucht',
  'bg.privateMovements': 'Private Bewegungen',
  'bg.reconcileAndArchive': 'Abstimmen und archivieren',
  'bg.backAndCheck': 'Zurück und prüfen',
  'bg.stepModeHelp': 'Schritt für Schritt führt dich jeweils durch eine Aufgabe. Die Gesamtübersicht zeigt alles zusammen.',
  'acc.sub': 'Dein Profil und die Unternehmen, auf die du Zugriff hast.',
  'acc.signOutHelp': 'Meldet dich von Plumme ab. Du musst dich erneut mit E-Mail und Passwort anmelden, um fortzufahren.',
  'acc.yourRole': 'Deine Rolle',
  'acc.yourRoleHelp': 'Die Rolle bestimmt, was du tun kannst: Inhaber hat vollen Zugriff, Administrator steuert den Betrieb, Buchhalter führt die Buchhaltung und Leser kann nur ansehen. Die Rolle kann sich von Unternehmen zu Unternehmen unterscheiden.',
  'acc.editProfile': 'Profil bearbeiten',
  'acc.myBusinesses': 'Meine Unternehmen',
  'acc.myBusinessesHelp': 'Die Unternehmen, auf die du in Plumme Zugriff hast. Das Etikett zeigt deine Rolle im jeweiligen Unternehmen. Tippe auf ein Unternehmen, um die Buchhaltung zu öffnen.',
  'acc.personalFinanceHelp': 'Privatfinanzen sind ein eigener Mandantentyp für persönliche Finanzen und Haushalt, getrennt von der Buchhaltung der Unternehmen.',
  'acc.goToPersonalFinance': 'Zu den Privatfinanzen',
  'acc.ownPersonalClient': 'Eigener Privatfinanzen-Mandant',
  'acc.myEmployers': 'Meine Arbeitgeber',
  'acc.myEmployersHelp': 'Unternehmen, bei denen du angestellt bist (für die du nicht unbedingt die Buchhaltung führst). Hier findest du nach und nach Lohnabrechnungen, Verträge und deine eigene Mitarbeiterseite.',
  'acc.employerPortalAccess': 'Unternehmen, für die du Zugang zum Mitarbeiterportal hast.',
  'acc.changePicture': 'Bild ändern',
  'acc.removePicture': 'Bild entfernen',
  'acc.photoUploading': 'Wird hochgeladen …',
  'acc.photoRemoving': 'Wird entfernt …',
  'acc.photoSaved': 'Das Profilbild wurde aktualisiert.',
  'acc.photoRemoved': 'Das Profilbild wurde entfernt.',
  'acc.photoWrongType': 'Wähle ein Bild im Format PNG, JPG oder WebP.',
  'acc.photoEmpty': 'Die Bilddatei ist leer.',
  'acc.photoTooLarge': 'Das Bild ist zu groß. Max. 2 MB.',
  'acc.photoUploadFailed': 'Das Profilbild konnte nicht hochgeladen werden.',
  'acc.photoRemoveFailed': 'Das Profilbild konnte nicht entfernt werden.',
  'acc.photoUnavailable': 'Profilbilder sind derzeit nicht verfügbar.',
  'acc.fullName': 'Vollständiger Name',
  'acc.phoneFromLogin': 'Telefon aus der Anmeldung',
  'acc.changePassword': 'Passwort ändern',
  'acc.changes': 'Änderungen',
  'acc.noChangeDetails': 'Für dieses Ereignis sind keine zusätzlichen Änderungsdetails gespeichert.',
  'acc.logSub': 'Was in der Buchhaltung getan wurde - und von wem.',
  'acc.logFilterHelp': 'Filtere das Protokoll nach Zeitraum, Bereich (z. B. Rechnung, Lohn, MwSt.) und welcher Benutzer die Aktion ausgeführt hat.',
  'acc.area': 'Bereich',
  'acc.areaHelp': 'Welchen Teil der Buchhaltung die Aktion betrifft - z. B. Rechnung, Einkauf, Lohn oder MwSt. Eine Aktion kann mehrere Bereiche berühren.',
  'acc.user': 'Benutzer',
  'acc.userHelp': 'Die Person, die die Aktion ausgeführt hat, mit ihrer Rolle. So siehst du, wer hinter jeder Änderung steht.',
  'acc.sentLinkTo': 'Wir haben einen Link gesendet an',
  'bud.annualBudget': 'Jahresbudget',
  'bud.suggestion': 'Budgetvorschlag',
  'bud.createSuggestion': 'Vorschlag erstellen',
  'bud.startSimpleQuestions': 'Mit einfachen Fragen beginnen',
  'bud.fillRelevant': 'Fülle nur aus, was relevant ist. Monatsbeträge werden in ein Jahresbudget umgerechnet.',
  'bud.businessDescription': 'Beschreibung des Unternehmens',
  'bud.businessDescriptionPh': 'Z. B. Transportunternehmen für 2027 mit 2 Lieferwagen, 2 Mitarbeitern, Büromiete 8 000/Monat und mehr Einnahmen im Sommer.',
  'bud.howToBudget': 'So erstellst du ein Budget',
  'bud.howToBudgetHelp': 'Wähle eine Methode: Bei „Manuell“ gibst du die Konten selbst ein, bei „Vorschlag“ beantwortest du ein paar einfache Fragen und erhältst einen Entwurf, und bei „AI-Vorschlag“ beschreibst du das Unternehmen in eigenen Worten und Plumme erstellt einen Entwurf.',
  'bud.budgetedResult': 'Budgetiertes Ergebnis',
  'bud.budgetedResultHelp': 'Das Ergebnis, das du für das ganze Jahr budgetiert hast — budgetierte Erträge minus budgetierte Aufwendungen. Das ist das Ziel, auf das du hinsteuerst.',
  'bud.actualResult': 'Tatsächliches Ergebnis',
  'bud.actualResultHelp': 'Das bisher in diesem Jahr gebuchte tatsächliche Ergebnis — tatsächliche Erträge minus tatsächliche Aufwendungen. Vergleiche es mit dem Budget, um zu sehen, ob du im Plan liegst.',
  'bud.postedSoFar': 'bisher gebucht',
  'bud.varianceToPeriod': 'Abweichung zum Zeitraum',
  'bud.varianceToPeriodHelp': 'Die Differenz zwischen tatsächlichem und budgetiertem Ergebnis bis jetzt. Eine negative Abweichung bedeutet, dass du unter dem Budget liegst, eine positive, dass du darüber liegst.',
  'bud.incomeTarget': 'Umsatzziel',
  'bud.incomeTargetHelp': 'Welchen Anteil der budgetierten Jahreserträge du bisher erreicht hast — tatsächlich fakturierte Erträge geteilt durch budgetierte Erträge.',
  'bud.ofTargetReached': 'des Ziels erreicht',
  'bud.viewHelp': 'Ansicht wechseln: „Übersicht“ zeigt das kumulierte Ergebnis und die größte Abweichung, „Analyse“ zeigt Erträge gegenüber Aufwendungen und das Ergebnis pro Monat, und unter „Budget nach Kategorie“ gibst du die Beträge ein und änderst sie.',
  'bud.accumulatedResult': 'Kumuliertes Ergebnis',
  'bud.accumulatedResultHelp': 'Das Diagramm zeigt, wie sich das Ergebnis Monat für Monat über das Jahr aufbaut. Die gestrichelte Linie ist das Budget, die durchgezogene das tatsächlich Gebuchte — so siehst du, ob du dem Plan folgst.',
  'bud.budgetAtYearEnd': 'Budget zum Jahresende',
  'bud.accumulated': 'kumuliert',
  'bud.actualSoFar': 'Tatsächlich bisher',
  'bud.posted': 'gebucht',
  'bud.varianceSoFar': 'Abweichung bisher',
  'bud.largestVariance': 'Größte Abweichung',
  'bud.largestVarianceHelp': 'Das Konto, das bisher in diesem Jahr am stärksten vom Budget abweicht. Hilfreich, um schnell zu sehen, wo du am meisten über oder unter deiner Planung liegst.',
  'bud.soFarThisYear': 'bisher in diesem Jahr',
  'bud.incomeVsCost': 'Erträge vs. Aufwendungen pro Monat',
  'bud.incomeVsCostHelp': 'Die Balken zeigen Erträge (grün) gegenüber Aufwendungen (orange) für jeden Monat. Wechsle zwischen Ist-Zahlen, Budgetzahlen oder beidem. Tippe auf einen Monat, um eine Auswahl zu summieren.',
  'bud.resultPerMonth': 'Ergebnis pro Monat',
  'bud.resultPerMonthHelp': 'Zeigt das Ergebnis (Erträge minus Aufwendungen) für jeden einzelnen Monat, Budget gegen Ist. Balken über der Mittellinie sind Gewinn, darunter Verlust.',
  'bud.actual': 'Ist',
  'bud.actualByCategory': 'Ist pro Kategorie',
  'bud.actualByCategoryHelp': 'Gebuchte Erträge und Aufwendungen pro Konto, nach Monat aufgeteilt. Die Zahlen stammen aus deiner Buchhaltung — sowohl in Plumme erfasste Belege als auch Zahlen aus einem Import — und aktualisieren sich von selbst.',
  'bud.noActuals': 'Noch keine gebuchten Zahlen für {year}.',
  'bud.actualOnlyHint': 'Das sind Ist-Zahlen. Lege unter Budget ein Budget an, wenn du dich an einem Plan messen willst.',
  'bud.byCategory': 'Budget pro Kategorie',
  'bud.addIncome': 'Ertrag hinzufügen',
  'bud.addIncomeHelp': 'Füge eine Ertragskategorie mit einem Jahresbetrag hinzu — z. B. erwarteter Umsatz. Der Betrag wird auf die Monate verteilt, was du anpassen kannst.',
  'bud.addCost': 'Kosten hinzufügen',
  'bud.addCostHelp': 'Füge eine Kostenkategorie mit einem Jahresbetrag hinzu — z. B. Miete, Wareneinkauf oder Software. Der Betrag wird auf die Monate verteilt, was du anpassen kannst.',
  'bud.noCategories': 'Noch keine Budgetkategorien. Füge Erträge oder Kosten hinzu.',
  'bud.useLastYear': 'Vorjahr verwenden',
  'bud.simpleQuestions': 'Einfache Fragen',
  'bud.byCategoryHelp': 'Jede Zeile ist eine Budgetkategorie. Die Beträge für alle 12 Monate sind immer sichtbar und direkt in der Tabelle bearbeitbar, mit der Jahressumme rechts.',
  'bud.total': 'Summe',
  'bud.annualTotal': 'Jahressumme',
  'bud.annualTotalHelp': 'Änderst du diese Zahl direkt, wird der neue Jahresbetrag gleichmäßig auf alle 12 Monate verteilt.',
  'bud.save': 'Speichern',
  'bud.methodManual': 'Manuell',
  'bud.methodSuggestion': 'Vorschlag',
  'bud.methodAi': 'AI-Vorschlag',
  'bud.modeBudgeted': 'Budgetiert',
  'bud.modeBoth': 'Beides',
  'bud.forWholeYear': 'für das ganze Jahr {year}',
  'bud.underBudget': 'unter Budget',
  'bud.overBudget': 'über Budget',
  'bud.legendBudgetDashed': '- - Budget',
  'bud.legendBudgetSolid': '— Budget',
  'bud.legendActual': '— Ist',
  'bud.noVarianceYet': 'Noch keine Abweichung',
  'bud.savedToast': 'Budget gespeichert',
  'bud.saveFailedToast': 'Budget konnte nicht gespeichert werden',
  'bud.aiModalTitle': 'AI-Budget für {year}',
  'bud.aiDraftBusy': 'Entwurf wird erstellt...',
  'bud.aiDraftCreate': 'Entwurf mit AI erstellen',
  'bud.aiDescription': 'Beschreibe das Unternehmen mit eigenen Worten: Mitarbeitende, Löhne, Vermögenswerte, Fixkosten und saisonale Schwankungen. Je mehr Details, desto besser der Entwurf.',
  'bud.aiDraftFailedGeneric': 'Ich konnte aus der Beschreibung keinen Budgetentwurf erstellen. Füge mehr Details hinzu oder nutze Vorschlag.',
  'bud.aiDraftAppliedToast': 'AI-Entwurf übernommen. Tippe auf Speichern, wenn er passt.',
  'bud.aiDraftFailed': 'AI-Budgetentwurf fehlgeschlagen.',
  'bud.suggestionIntro': 'Erstelle einen Vorschlag aus den Ist-Zahlen des Vorjahres oder beantworte ein paar einfache Fragen für ein Startbudget.',
  'bud.catSales': 'Verkauf von Waren und Dienstleistungen',
  'bud.catPurchases': 'Wareneinkauf und direkte Kosten',
  'bud.catPremises': 'Räumlichkeiten',
  'bud.catSoftware': 'Software und Ausstattung',
  'bud.catAccounting': 'Buchhaltung und Beratung',
  'bud.catTravel': 'Reisen',
  'bud.catMarketing': 'Marketing',
  'bud.catCommunication': 'Telefon, Porto und Kommunikation',
  'bud.otherCosts': 'Sonstige Kosten',
  'bud.customCategory': 'Eigene Kategorie',
  'bud.q.expectedIncome.label': 'Wie viel willst du verdienen?',
  'bud.q.expectedIncome.hint': 'Erwartete fakturierte Erträge für das ganze Jahr.',
  'bud.q.goodsAnnual.label': 'Wareneinkauf',
  'bud.q.goodsAnnual.hint': 'Waren oder Material, die du zum Verkauf einkaufst.',
  'bud.q.officeMonthly.label': 'Büro/Räume pro Monat',
  'bud.q.officeMonthly.hint': 'Miete, Büroplatz oder Räumlichkeiten.',
  'bud.q.softwareMonthly.label': 'Software pro Monat',
  'bud.q.softwareMonthly.hint': 'Abonnements, Tools und Apps.',
  'bud.q.accountingMonthly.label': 'Buchhaltung/Beratung pro Monat',
  'bud.q.accountingMonthly.hint': 'Buchhalter, Berater oder sonstige Hilfe.',
  'bud.q.travelAnnual.label': 'Auto/Reisen pro Jahr',
  'bud.q.travelAnnual.hint': 'Fahrten, Reisen, Hotel oder Transport.',
  'bud.q.marketingAnnual.label': 'Marketing pro Jahr',
  'bud.q.marketingAnnual.hint': 'Anzeigen, Profilierung und Vertriebskosten.',
  'bud.q.otherAnnual.hint': 'Plane einen Puffer für das ein, was du noch nicht weißt.',
  'aii.superPlumma': 'SuperPlumma',
  'aii.askSuperPlumma': 'SuperPlumma fragen',
  'aii.chatWithSuperPlumma': 'Mit SuperPlumma chatten',
  'aii.chatWithMe': 'Chatte mit mir',
  'aii.healthScore': 'Finanzieller Gesundheitsscore',
  'po.title': 'Privatfinanzen',
  'po.backToBusiness': 'Zurück zum Unternehmen',
  'po.yourAdvisor': 'Dein privater Berater',
  'po.intro': 'Privatfinanzen sind deine persönlichen Finanzen — vollständig getrennt von der Unternehmensbuchhaltung. SuperPlumma analysiert Einkommen, Ausgaben, Ersparnisse, Kredite, Rente und Steuern des Haushalts und berät dich wie ein privater Finanzberater. „Beta“ bedeutet, dass die Funktion noch in Entwicklung ist.',
  'po.hero.greeting.night': 'Gute Nacht.',
  'po.hero.greeting.morning': 'Guten Morgen.',
  'po.hero.greeting.day': 'Hallo.',
  'po.hero.greeting.evening': 'Guten Abend.',
  'po.hero.greetingNamed.night': 'Gute Nacht, {name}.',
  'po.hero.greetingNamed.morning': 'Guten Morgen, {name}.',
  'po.hero.greetingNamed.day': 'Hallo, {name}.',
  'po.hero.greetingNamed.evening': 'Guten Abend, {name}.',
  'po.hero.section.idag': 'Rat des Tages',
  'po.hero.section.oversikt': 'Finanzübersicht',
  'po.hero.section.forbruk': 'Ausgaben',
  'po.hero.section.familie': 'Familienfinanzen',
  'po.hero.section.fremtid': 'Zukunftsplan',
  'po.hero.section.reports': 'Berichte',
  'po.hero.section.assets': 'Vermögenswerte',
  'po.hero.section.gjeld': 'Schulden',
  'po.hero.section.import': 'Datengrundlage',
  'po.hero.advice.idag': 'Ich behalte deine Finanzen im Blick und hebe die wichtigsten Aufgaben und Möglichkeiten im Moment hervor.',
  'po.hero.advice.oversikt': 'Sieh, was deine finanzielle Gesundheit nach oben und unten zieht. Beginne mit dem Bereich, der am meisten Aufmerksamkeit braucht.',
  'po.hero.advice.forbruk': 'Achte auf Kategorien, die gestiegen sind, und wähle einen realistischen Schritt, der mehr Spielraum schafft, ohne den Alltag zu eng zu machen.',
  'po.hero.advice.familie': 'Kläre, was gemeinsam ist, wer was bezahlt und welche Ziele der Haushalt gemeinsam priorisieren soll.',
  'po.hero.advice.fremtid': 'Mach deine Ziele mit Betrag und Datum konkret. So siehst du leichter, was du jeden Monat sparen solltest.',
  'po.hero.advice.reports': 'Nutze die Berichte, um die Entwicklung über die Zeit zu verstehen, nicht nur einen einzelnen hohen oder niedrigen Monatsbetrag.',
  'po.hero.advice.assets': 'Prüfe, ob Werte und Kontostände aktuell sind, bevor du Nettovermögen und langfristige Entscheidungen bewertest.',
  'po.hero.advice.gjeld': 'Baue zuerst einen sicheren Puffer auf und erwäge dann Sondertilgungen bei der Schuld mit dem höchsten Effektivzins.',
  'po.hero.advice.import': 'Guter Rat beginnt mit guten Daten. Verknüpfe die Kontoauszüge mit dem richtigen Konto und schließe Lücken in den Zeiträumen.',
  'po.pickPerson': 'Person wählen',
  'po.sections': 'Bereiche',
  'po.sectionsHelp': 'Wechsle zwischen den Bereichen: Heute (Erkenntnisse des Tages), Übersicht (Gesundheitsscore und Kennzahlen), Ausgaben (wohin das Geld geht), Familie, Zukunft (Prognose und „Was wäre, wenn“), Berichte, Vermögenswerte, Schulden, Steuern und Import.',
  'po.outOf100': 'von 100',
  'po.todaysFocus': 'Fokus heute',
  'po.todaysTasks': 'Aufgaben heute',
  'po.mostImportantToday': 'Heute am wichtigsten',
  'po.markDone': 'Als erledigt markieren',
  'po.undo': 'Rückgängig',
  'po.healthHeading': 'Deine finanzielle Gesundheit insgesamt — und was sie beeinflusst',
  'po.healthHelp': 'Die Zahl im Ring (0–100) ist eine Gesamtbewertung deiner Finanzen — je höher, desto gesünder. Die Kategorien darunter zeigen, was nach oben und unten zieht: Grün ist gut, Gelb heißt im Blick behalten, und Rot braucht Aufmerksamkeit.',
  'po.noHistory': 'Noch keine Historie zum Vergleichen',
  'po.whatAffectsScore': 'Was den Score am stärksten beeinflusst',
  'po.noDrivers': 'Noch keine Treiber berechnet',
  'po.noDriversHelp': 'Sobald genug Transaktionen importiert sind, zeige ich, was den Score nach oben und unten zieht.',
  'po.last30Days': 'Zuletzt erfasster Monat',
  'po.last30DaysSub': 'Verglichen mit dem vorherigen Kalendermonat',
  'po.financialOverview': 'Finanzübersicht',
  'po.financialOverviewSub': 'Eine Momentaufnahme der Haushaltsfinanzen',
  'po.recommendations': 'SuperPlummas Empfehlungen',
  'po.recommendationsSub': 'Die Schritte, die für deine Finanzen gerade am meisten zählen',
  'po.askMe': 'Frag mich',
  'po.yourHealthScoreIs': 'Dein Gesundheitsscore ist',
  'po.adjustBudget': 'Budget anpassen',
  'po.budgetTotal': 'Budget gesamt:',
  'po.saveBudget': 'Budget speichern',
  'po.monthlyLimitPerCategory': 'Monatliches Limit pro Kategorie',
  'po.noCategoriesImported': 'Noch keine Ausgabenkategorien importiert. Füge unten eigene Kategorien hinzu.',
  'po.ownCategories': 'Eigene Kategorien',
  'po.pickColour': 'Farbe wählen',
  'po.categoryName': 'Name der Kategorie',
  'po.removeCategory': 'Kategorie entfernen',
  'po.addCategory': 'Kategorie hinzufügen',
  'po.budgetVsSpending': 'Budget vs. Ausgaben',
  'po.budgetVsSpendingSub': 'Monatliches Limit gegenüber den Ausgaben im gewählten Zeitraum',
  'po.budgetVsSpendingHelp': 'Monatliches Budget gegenüber den tatsächlichen Ausgaben pro Kategorie. Tippe auf „Budget anpassen“, um die Limits festzulegen oder eigene Kategorien anzulegen. Der Fortschrittsbalken füllt sich danach, wie viel vom Budget du verbraucht hast — Grün ist im Rahmen, Gelb nähert sich dem Limit, und Rot bedeutet, dass die Kategorie überschritten ist. Wählst du die Jahresübersicht, wird das monatliche Limit mit der Anzahl der Monate mit importierten Daten multipliziert. Die Budgets werden für das gewählte Jahr gespeichert.',
  'po.whereMoneyGoes': 'Wohin geht das Geld?',
  'po.whereMoneyGoesSub': 'Tippe auf eine Kategorie, um die Transaktionen dahinter zu sehen und an die richtige Stelle zu verschieben',
  'po.whereMoneyGoesHelp': 'Das Kreisdiagramm und die Liste zeigen die Ausgaben nach Kategorien für den gewählten Zeitraum. Wechsle den Zeitraum mit der Schaltfläche oben — Monate ohne importierte Transaktionen sind grau. Tippe auf eine Kategorie, um sie hervorzuheben. Der Prozentsatz rechts ist die Veränderung gegenüber dem Vormonat — Grün nach unten bedeutet weniger, Rot nach oben bedeutet mehr.',
  'po.selectPeriod': 'Zeitraum wählen',
  'po.yearOverview': 'Jahresübersicht',
  'po.yearly': 'Jährlich',
  'po.month.1': 'Januar',
  'po.month.2': 'Februar',
  'po.month.3': 'März',
  'po.month.4': 'April',
  'po.month.5': 'Mai',
  'po.month.6': 'Juni',
  'po.month.7': 'Juli',
  'po.month.8': 'August',
  'po.month.9': 'September',
  'po.month.10': 'Oktober',
  'po.month.11': 'November',
  'po.month.12': 'Dezember',
  'po.largestCategoryIs': 'Die größte Kostenkategorie ist',
  'po.recurringCharges': 'Feste Abbuchungen zum Prüfen',
  'po.recurringChargesSub': 'Wiederkehrende Abo-Abbuchungen, die eine Prüfung wert sein können',
  'po.opportunity': 'Möglichkeit',
  'po.estimatedAnnualCost': 'Geschätzte jährliche Kosten',
  'po.saveAccount': 'Konto speichern',
  'po.allAccounts': 'Alle Konten',
  'po.uploadedStatements': 'Hochgeladene Kontoauszüge',
  'po.yourAccounts': 'Deine Konten',
  'po.yourAccountsSub': 'Erfasse und sortiere deine Konten nach Typ — importierte Kontoauszüge werden dem richtigen Konto zugeordnet',
  'po.totalBalance': 'Guthaben gesamt',
  'po.creditDebt': 'Kreditkartenschulden',
  'po.accounts': 'Konten',
  'po.analysis': 'SuperPlummas Analyse',
  'po.analysisSub': 'Wie sich die Ausgaben in der Kategorie verteilen — und was du tun kannst',
  'po.whoIsBehind': 'Wer steckt dahinter',
  'po.noTransactionsToAnalyse': 'Noch keine Transaktionen zum Analysieren.',
  'po.unusualPurchases': 'Ungewöhnliche Käufe',
  'po.noUnusualPurchases': 'In diesem Zeitraum fallen keine Käufe auf.',
  'po.searchTransactions': 'Transaktionen durchsuchen …',
  'po.clearSearch': 'Suche leeren',
  'po.sort': 'Sortieren',
  'po.linkStatementToAccount': 'Kontoauszug mit Konto verknüpfen',
  'po.linkToAccount': 'Mit Konto verknüpfen',
  'po.newAccount': 'Neues Konto',
  'po.accountNamePh': 'Z. B. DNB Girokonto',
  'po.accountNumberPh': 'Z. B. 1234.56.78901',
  'po.currentAccount': 'Girokonto',
  'po.creditCard': 'Kreditkarte',
  'po.me': 'ich',
  'po.importTitle': 'Finanzdaten importieren',
  'po.importSub': 'Lade Kontoauszüge hoch — SuperPlumma liest und kategorisiert automatisch',
  'po.pickStatement': 'Kontoauszug der Bank wählen',
  'po.pickStatementHelp': 'Lade Kontoauszüge deiner Bank hoch. XLSX und CSV werden direkt gelesen, PDF nach bestem Vermögen aus dem Text. SuperPlumma kategorisiert die Transaktionen automatisch.',
  'po.pdf': 'PDF',
  'po.noStatementsUploaded': 'Es wurden noch keine Kontoauszüge hochgeladen.',
  'po.deleteStatement': 'Kontoauszug löschen',
  'po.sharedCosts': 'Beitrag zu gemeinsamen Kosten',
  'po.sharedCostsSub': 'Wer zahlt was von den gemeinsamen Ausgaben — und wie das im Verhältnis zum Einkommensanteil steht',
  'po.sharedCostsHelp': 'Der Balken zeigt, welchen Anteil der gemeinsamen Haushaltskosten jede bzw. jeder von euch trägt. Rechts steht der Anteil am Gesamteinkommen. Sind beide gleich groß, ist die Aufteilung einkommensproportional. Die Zahlen stammen aus dem, was jede bzw. jeder von euch im eigenen Profil eingetragen hat.',
  'po.splitIsEven': 'Die Aufteilung ist ausgeglichen. Ihr teilt',
  'po.togetherYouCan': 'Gemeinsam könnt ihr',
  'po.togetherYouCanSub': 'Kleine Schritte, die ihr als Team gehen könnt — berechnet aus den eigenen Zahlen des Haushalts',
  'po.togetherHelp': 'Die Vorschläge sind aus dem Gesamteinkommen und den gemeinsamen Kosten berechnet, die ihr eingetragen habt. Sie sind als gemeinsame Ziele gedacht, nicht als Anforderungen an Einzelne.',
  'po.sharedSteps': 'Gemeinsame Schritte',
  'po.magnitude': 'Größenordnung',
  'po.youPartnerPh': 'Du, Partner …',
  'po.monthlyNetIncome': 'Monatliches Nettoeinkommen',
  'po.sharedCostShare': 'Anteil gemeinsamer Kosten pro Monat',
  'po.familyFinances': 'Familienfinanzen',
  'po.addPerson': 'Person hinzufügen',
  'po.noHouseholdMembers': 'Es sind noch keine Haushaltsmitglieder erfasst.',
  'po.householdHasRegistered': 'Der Haushalt hat erfasst',
  'po.todaysPlan': 'Plan für heute',
  'po.savePlan': 'Plan speichern',
  'po.monthlySaving': 'Monatliches Sparen (NOK)',
  'po.monthlyExtraDebt': 'Monatliche Sondertilgung (NOK)',
  'po.targetNetWealth': 'Gewünschtes Nettovermögen (NOK)',
  'po.expectedReturn': 'Erwartete jährliche Rendite (%)',
  'po.yourAgeToday': 'Dein Alter heute (Jahre)',
  'po.desiredRetirementAge': 'Gewünschtes Rentenalter (Jahre)',
  'po.pickEvent': 'Ereignis wählen',
  'po.eventNamePh': 'Z. B. Zweites Kind',
  'po.starts': 'Beginnt',
  'po.oneOffCost': 'Einmalige Kosten (NOK)',
  'po.monthlyEffect': 'Monatliche Auswirkung (NOK)',
  'po.durationMonths': 'Dauer (Monate)',
  'po.goalName': 'Name des Ziels',
  'po.goalNamePh': 'Z. B. Rücklage',
  'po.shortDescription': 'Kurzbeschreibung',
  'po.whatSavingFor': 'Wofür sparst du?',
  'po.targetAmount': 'Zielbetrag (NOK)',
  'po.savedSoFar': 'Bisher gespart (NOK)',
  'po.icon': 'Symbol',
  'po.colour': 'Farbe',
  'po.debtFree': 'Schuldenfrei',
  'po.saveLoan': 'Darlehen speichern',
  'po.loanType': 'Darlehensart',
  'po.spendingCategory': 'Kategorie in Ausgaben',
  'po.categoryPh': 'Z. B. Wohnen',
  'po.debtOverview': 'Schuldenübersicht',
  'po.debtOverviewSub': 'Alle deine Darlehen zusammen — Restschuld, Zinsen und Tilgungstempo',
  'po.debtOverviewHelp': 'Die Kennzahlen für alle deine Schulden: gesamte Restschuld, was du pro Monat tilgst, Zinskosten pro Jahr, Durchschnittszins und wie lange es dauert, bis du schuldenfrei bist.',
  'po.totalDebt': 'Gesamtschulden',
  'po.repaymentPerMonth': 'Tilgung pro Monat',
  'po.interestPerYear': 'Zinsen pro Jahr',
  'po.averageRate': 'Durchschnittszins',
  'po.debtFreeIn': 'Schuldenfrei in',
  'po.loanCount': 'Anzahl Darlehen',
  'po.yourLoans': 'Deine Darlehen',
  'po.yourLoansSub': 'Tippe auf ein Darlehen, um den Tilgungsplan zu sehen und Änderungen zu simulieren',
  'po.addLoan': 'Darlehen hinzufügen',
  'po.noLoans': 'Noch keine Darlehen erfasst. Tippe auf „Darlehen hinzufügen“, um loszulegen.',
  'po.whichLoanFirst': 'Welche Darlehen solltest du zuerst tilgen?',
  'po.whichLoanFirstSub': 'Nach Zinssatz sortiert — das teuerste Darlehen zuerst bringt am meisten für jede zusätzliche Krone',
  'po.iRecommend': 'Ich empfehle',
  'po.snowballWithRate': 'die Zinsmethode (Lawinenmethode)',
  'po.repaymentSimSub': 'Sieh, wie die Restschuld sinkt, und simuliere, was passiert, wenn du pro Monat mehr oder weniger zahlst',
  'po.myRecommendation': 'Meine Empfehlung',
  'po.withChange': 'Mit Änderung',
  'po.extraRepaymentPerMonth': 'Zusätzliche Tilgung pro Monat',
  'po.dragToPayMore': 'Ziehe, um mehr zu zahlen (schneller schuldenfrei) oder weniger (längere Laufzeit)',
  'po.standard': 'Standard',
  'po.savedInInterest': 'Gesparte Zinsen',
  'po.overWholeTerm': 'über die gesamte Laufzeit',
  'po.netWealthEffect': 'Effekt auf das Nettovermögen',
  'po.becomesYours': 'gehört dir, nicht der Bank',
  'po.interestPostedAs': 'Zinsen und Tilgungen für dieses Darlehen werden gebucht als',
  'po.debtJourney': 'Dein Weg aus den Schulden',
  'po.debtJourneySub': 'Die wichtigsten Meilensteine auf dem Weg zur vollständigen Schuldenfreiheit',
  'po.yourFinancialFuture': 'Deine finanzielle Zukunft',
  'po.yourFinancialFutureSub': 'Wohin dich das Geld bringt — und wie deine Entscheidungen den Weg dorthin prägen',
  'po.showingScenario': 'Angezeigtes Szenario:',
  'po.reset': 'Zurücksetzen',
  'po.desiredNetWealth': 'Gewünschtes Nettovermögen',
  'po.lastsUntilYouAre': 'reicht, bis du',
  'po.lasts': 'reicht',
  'po.forLife': 'ein Leben lang',
  'po.plummaReadsChart': 'SuperPlumma liest das Diagramm',
  'po.whatIf': 'Was passiert, wenn?',
  'po.whatIfSub': 'Lege den Ausgangspunkt im heutigen Plan fest, wähle eine Entscheidung und passe die Annahmen an — dann werden Diagramm, Ziele, Termine und Rente gleichzeitig aktualisiert',
});
